module.exports = __webpack_public_path__ + "img/vue2-corpsarr_lavande.910de896.png";